export default __webpack_public_path__ + "static/skills-d5f2f2ea9e21fb90dd48cf3845a93fdc.jpg";